import { ModelApiService } from './BaseApiService'

export default class ClientGroupApiService extends ModelApiService {
  constructor() {
    super('client-groups')
  }

  async getOverviewData(clientGroupId, filterDate, timeZone) {
    return this.get(`${clientGroupId}/overview`, { filterDate, timeZone })
  }
}
